import React from "react";
import get from "lodash/get";
import { array, bool, object, string } from "prop-types";

import NewsHeadline from "../../atoms/NewsHeadline";
import CardImage from "../../atoms/CardImage";
import SponsorDetails from "../SponsorDetails";
import Excerpt from "../../atoms/Excerpt";
import StoryMetaData from "../../molecules/StoryMetaData";

import { getExcerpt } from "../../utils/utils";

import "./newsWithImage.m.css";

const NewsWithImage = ({
  story,
  aspectRatio = [3, 2],
  imageType = "image3x2",
  widths = [250, 480, 764],
  styles = {},
  showSubHeading = true,
  showExcerpt = false,
  cssStyleName = "",
  showDot = false,
  className = "",
  showPublishedAt = true,
  iconEnd = false,
}) => {
  if (!story) return null;
  const excerpt = showExcerpt ? getExcerpt(story) : "";
  const sponsorId = get(story, ["metadata", "story-attributes", "sponsoredby", "0", "id"], null);
  const showLiveBlog = story["story-template"] === "live-blog";

  const sponsor = sponsorId && !showLiveBlog;

  return (
    <div className={`news_with_item ${className}`} styleName="wrapper" style={styles}>
      <CardImage
        className="card-with-image-zoom"
        story={story}
        aspectRatio={aspectRatio}
        imageType={imageType}
        widths={widths}
        linkEnable={true}
        showStoryTypeIcon={!iconEnd}
      />

      <NewsHeadline
        story={story}
        showDot={showDot}
        cssStyleName={cssStyleName}
        styles={styles}
        showSubHeading={showSubHeading}
      />

      <Excerpt excerpt={excerpt} url={story.url} />
      {sponsor ? (
        <SponsorDetails sponsorId={sponsorId} showImage={false} />
      ) : (
        <StoryMetaData story={story} isPublished={showPublishedAt} />
      )}
    </div>
  );
};

NewsWithImage.propTypes = {
  story: object.isRequired,
  aspectRatio: array,
  imageType: string,
  widths: array,
  styles: object,
  showSubHeading: bool,
  showExcerpt: bool,
  cssStyleName: string,
  showDot: bool,
  className: string,
  showPublishedAt: bool,
  iconEnd: bool,
};

export default NewsWithImage;
